import { FunctionComponent, useState } from 'react';
import styles from './Notification.module.scss';
import Icon from '../../DataDisplay/Icon/Icon';
import Counter from './Counter/Counter';
import Tooltip from '../Tooltip/Tooltip';

export type NotificationProps = {
  variant?: 'alarm' | 'message';
  counts?: number;
  iconColor?: 'black' | 'white';
  description?: string | undefined;
};

type FC = FunctionComponent<NotificationProps>;

const Notification: FC = ({ variant = 'alarm', counts = 0, iconColor, description }: NotificationProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const mouseOver = () => {
    setIsTooltipVisible(true);
  };

  const mouseLeave = () => {
    setIsTooltipVisible(false);
  };

  return (
    <div className={styles.container} onMouseLeave={mouseLeave} onMouseOver={mouseOver}>
      {counts >= 1 ? <Counter counts={counts} /> : <></>}
      <Icon icon={variant === 'message' ? 'mail' : 'alarm'} color={getColor()} width="13px" />
      {isTooltipVisible && <Tooltip information={description} />}
    </div>
  );

  function getColor() {
    return iconColor === 'black' ? 'primary-dark' : iconColor === 'white' ? 'primary-light' : 'primary-dark';
  }
};

export default Notification;
